import { createGlobalKey } from "@aviv-unified-frontend/internal";
export const APP_VERION_KEY = createGlobalKey("app_version").toLocaleLowerCase();
